import type {Ref} from 'vue'
import _ from 'lodash'

export default function hasBeenCalledWithConfig(currentConfig: Ref, newConfig: Ref) {
  return _.isEqual(currentConfig.value, newConfig.value)
}
